import { useEffect, useState } from "react";
import { Button, Dropdown, Form, Modal } from "react-bootstrap";
import { BsPerson, BsBoxArrowRight, BsPen, BsTelephone } from "react-icons/bs";
import Api from "../../api/Api";


const ChangePassword = () => {
    const [show, setShow] = useState(false);
    
    const [field_typesFlag, setFieldTypesFlag]=useState(false);
    const [field_types, setFieldTypes]=useState("password");

    const [newPasswordValue,setNewPasswordValue]=useState("");
    useEffect(()=>{
        if(field_typesFlag){
            setFieldTypes("text")
        }else{
            setFieldTypes("password");
        }
        
    },[field_typesFlag])

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);


    const checkUpperScale = (pwd) => /[A-ZА-ЯЁ]/.test(pwd);
    const checkLowerScale = (pwd) => /[a-zа-яё]/.test(pwd);
    const checkNumiric = (pwd) => /[0-9]/.test(pwd);
    const checkSpecialSymbols = (pwd) => /[!@#$%^&*(),.?":{}|<>/]/.test(pwd);
    const checkLength = (pwd) => pwd.length > 10;

    const send_data = async(data) =>{
        try {
            await Api({
                method:"post",
                url:`/auth/update_password`,
                headers:{},
                data:data
            })
            alert("Пароль обновлён.");
            handleClose();
            window.location.reload();
        } catch (error) {
            alert(`Ошибка при обновлении пароля \n ${error}`);
            handleClose();
        }
    }

    const setColor = (ruleCheck) => {
        if(newPasswordValue!==""){
            switch (ruleCheck){
                case true:
                    return {color:"green"};
                case false:
                    return {color:"red"};
                default:
                    return {color:"black"};
            }
        }else{
            return {color:"black"};
        }
    }

    const handleSend = async(e) => {
        e.preventDefault();
        if (checkLength(newPasswordValue) && checkLowerScale(newPasswordValue) && checkNumiric(newPasswordValue)
        && checkSpecialSymbols(newPasswordValue) && checkUpperScale(newPasswordValue)) {
            const data={
                old_password:document.getElementById("old_password").value,
                new_password:document.getElementById("new_password").value
            }
            await send_data(data);
        }else{
            alert("Не соблюдены требования к паролю!")
        }
        // const data={
        //         old_password:document.getElementById("old_password").value,
        //         new_password:document.getElementById("new_password").value
        //     }
        // await send_data(data);
    }

    return(
        <>
            <Dropdown.Item onClick={handleShow}><BsPen /> Сменить пароль</Dropdown.Item>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                <Modal.Title className="text_font">Изменить пароль</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSend}>
                        <div>
                            <Form.Control 
                            placeholder="Старый пароль..."
                            id="old_password"
                            type={field_types}
                            required
                            />
                            <div className="text-mutted">
                                <span>Требования к паролю:</span>
                                <ul>
                                    <li style={setColor(checkLength(newPasswordValue))}>От 10 символов;</li>
                                    <li style={setColor(checkLowerScale(newPasswordValue))}>Минимум одна прописная буква(abcdef...z);</li>
                                    <li style={setColor(checkUpperScale(newPasswordValue))}>Минимум одна заглавная буква(ABCDEF...Z);</li>
                                    <li style={setColor(checkNumiric(newPasswordValue))}>Минимум одна цифра(12345...0);</li>
                                    <li style={setColor(checkSpecialSymbols(newPasswordValue))}>Минимум один спецсимвол(!$@%^.../);</li>
                                </ul>
                            </div>
                            <Form.Control 
                            onChange={(e)=>setNewPasswordValue(e.target.value)}
                            placeholder="Новый пароль..."
                            id="new_password"
                            type={field_types}
                            required
                            />
                        </div>
                        <div className="mt-1 mb-1">
                            <Form.Check 
                            className="mt-1 mb-1" 
                            type="switch"
                            checked={field_typesFlag}
                            onChange={(e)=>{setFieldTypesFlag(e.target.checked)}}
                            label={"Скрыть/Показать пароль."}></Form.Check>
                        </div>
                        <div className="mt-1" style={{display:"flex", justifyContent:"space-between"}}>
                            <Button 
                                onClick={handleClose}
                                variant="light" 
                                className="free-btn m-1 border btn-round">Отменить</Button>
                            <Button 
                            className="free-btn custom-btn m-1" 
                            type="submit">Изменить пароль</Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    )
}

const СontactInfo = () => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const info=`Маркова Татьяна Алексеевна \n Email: MarkovaTA@ao-zdrm.ru \n Телефон: +7-499-262-88-28, доб. 97603 \n\n Прошин Михаил Игоревич \n Email: ProshinMI@ao-zdrm.ru`

    return(
        <>
            <Dropdown.Item onClick={handleShow}><BsTelephone /> Контактная информация</Dropdown.Item>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title className="text_font">Контактная информация</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="sepatate_text text_font">{info}</p>
                </Modal.Body>
            </Modal>
        </>
    )
}

const PersonDropdown = () =>{
    const user_data = JSON.parse(sessionStorage.getItem('user_data'))
    const role_full={
        "Admin":"Администратор",
        "Moderator":"Модератор",
        "User":"Пользователь",
        "Auditor":"Аудитор",
        "Admin-RO":"Администратор наблюдатель"
    }

    const logout = async() => {
        let warning = window.confirm("Выйти из системы?");
        if (warning){
            try {
                await Api({
                    method:"post",
                    url:`/auth/logout`,
                    headers:{}
                });
                sessionStorage.removeItem('user_data');
                window.location.href="/";
            } catch (error) {
                alert(`Ошибка при выходе из системы \n ${error}`)
            }
        }
    }
    
    return(
        <>
            <Dropdown align="end">
                <Dropdown.Toggle   
                    size="md" 
                    variant="light" 
                    className="border d-flex justify-content-center align-items-center gap-1">
                    <BsPerson />
                    <span>{user_data.username || "Пользователь"}</span>
                </Dropdown.Toggle>

                <Dropdown.Menu className="dropdownPersonBlock">
                    <div className="m-2 d-flex flex-column gap-1 text_font">
                        <div>Логин: {user_data.username}</div>
                        <div>ФИО: {user_data.surname || ""} {user_data.name || ""} {user_data.patronymic || ""}</div>
                        <div>Роль: {role_full[user_data.role]}</div>
                    </div>
                    <СontactInfo/>
                    <ChangePassword/>
                    <Dropdown.Item onClick={()=>logout()} className="warning_text"><BsBoxArrowRight /> Выйти из аккаунта</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </>
    )
}

export default PersonDropdown;